import PropTypes from 'prop-types';

export default function SectionCover({ title, subtitle, accent_color }) {
  return (
    <div className="ppt-container items-center justify-center text-center">
      <div className="flex h-full flex-1 flex-col items-center justify-center gap-4 md:gap-6 text-center px-4">
        <h1 style={{ color: accent_color }} className="text-3xl md:text-5xl lg:text-7xl font-bold tracking-tight">
          {title}
        </h1>
        {subtitle && <h2 className="text-xl md:text-2xl lg:text-3xl text-slate-600">{subtitle}</h2>}
      </div>
    </div>
  );
}

SectionCover.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  accent_color: PropTypes.string,
};
